class MetricContainer {
    metric: number;
    metricExpression: Metric;
    isExpression: boolean;
    comparisonType: ComparisonMetricType;
    comparisonFilterId: string;
    
    private _functionType: KnockoutObservable<FunctionTypeEnum> = ko.observable();
    functionType: KnockoutComputed<FunctionTypeEnum> = ko.pureComputed({
        read: function (this: MetricContainer) {
            return this.metricObject.groupingType === GroupingTypeEnum.TSUM ? FunctionTypeEnum.Normal : this._functionType();
        },
        write: function (this: MetricContainer, value: FunctionTypeEnum) {
            this._functionType(value);
        },
        owner: this
    });

    private _metricObject: Metric;
    get metricObject(): Metric {
        if (!this._metricObject) {
            this._metricObject = this.isExpression ? this.metricExpression : MappingService.getMetric(this.metric);
        }
        return this._metricObject;
    }

    get queryName() {
        return `M${this.metricObject.id}_T${this.functionType()}_C${this.comparisonType}_F${this.comparisonFilterId}`;
    } 
    get parentQueryName(): string {
        if (this.metric) {
            //return `M${this.metricObject.id}_T${this.functionType()}_C${ComparisonMetricType.None}_F`;
            return this.getParentQueryNameForFunction(this.functionType());
        }
        return null;
    }

    getParentQueryNameForFunction(functionType: FunctionTypeEnum) {
        return `M${this.metricObject.id}_T${functionType}_C${ComparisonMetricType.None}_F`;
    }

    get displayName() {
        switch (this.comparisonType) {
            case ComparisonMetricType.Value:
                return `${this.metricObject.metricName} Filter ${this.comparisonFilterId}`;
            case ComparisonMetricType.Variation:
                return `${this.metricObject.metricName} Filter ${this.comparisonFilterId} Var.`;
            case ComparisonMetricType.PercentageVariation:
                return `${this.metricObject.metricName} Filter ${this.comparisonFilterId} % Var.`;
            default:
                return this.metricObject.metricName;
        }
    }

    get originalName() {
        switch (this.comparisonType) {
            case ComparisonMetricType.Value:
                return `${this.metricObject.originalName} Filter ${this.comparisonFilterId}`;
            case ComparisonMetricType.Variation:
                return `${this.metricObject.originalName} Filter ${this.comparisonFilterId} Var.`;
            case ComparisonMetricType.PercentageVariation:
                return `${this.metricObject.originalName} Filter ${this.comparisonFilterId} % Var.`;
            default:
                return this.metricObject.originalName;
        }
    }

    get tableName() {
        return this.metricObject.tableName ?? "Metrics";
    }

    constructor(data) {
        if (!data) {
            return;
        }

        this.metric = data.metric;
        if (data.metricExpression) {
            this.metricExpression = new Metric(data.metricExpression);
        }
        this.isExpression = data.isExpression;
        this.comparisonType = data.comparisonType;
        this.comparisonFilterId = data.comparisonFilterId ?? "";
        this.functionType(data.functionType);
    }
}